import { useEffect, useState } from 'preact/hooks';
import useApp from '../context/AppContext';
import useTable from '../context/TableContext';
import {useToaster} from '../context/ToasterContext';
import { getBehhhInfo, login } from '../api/api';

export default function Menu() {

    const [newVersion, setNewVersion] = useState(null);
    const [apiQueue, setApiQueue] = useState([]);
    const [displayArchive, setDisplayArchive] = useState(false);
    const [connected, setConnected] = useState(localStorage.getItem('connected'));
    const [username, setUsername] = useState(localStorage.getItem('username'));
    const { setAnimals, setLocations, setMarkers, setEvents, setCategories, loadData, manageApiQueue, checkToken, config, setConfig } = useApp();
    const { tableData, setTableData } = useTable();  
    const addToast = useToaster();

    const checkNewVersion = (info) => {
        if (process.env.PREACT_APP_BEHHH_VERSION !== info.version) {
            setNewVersion('Il y a une nouvelle version de l\'appli (' + info.version + ') disponible, veillez à synchroniser vos données, supprimez l\'appli et réinstallez là.');
        } else {
            setNewVersion('');
        }
    }

    useEffect(() => {
        setDisplayArchive(localStorage.getItem('displayArchive') && localStorage.getItem('displayArchive') == "true" );
        setApiQueue(JSON.parse(localStorage.getItem('api_queue') || "[]") || []);
        checkToken().then((resp) => {
            if (resp) {
                getBehhhInfo().then(info => {
                    if (info.code && info.code == '401') {
                        addToast('warning', 'Veuillez vous connecter avec vos identifiants.');
                    }
                    else {
                        checkNewVersion(info);
                    }
                })
            }
        })
    }, []);

    const handleRefreshData = () => {
        manageApiQueue().then(() => {
            setApiQueue(JSON.parse(localStorage.getItem('api_queue') || '[]') || []);
        })
        loadData(tableData, setTableData, setAnimals, setLocations, setMarkers, setEvents, setCategories, setConfig)
            .then(() => {
                //addToast('success', 'Données mises à jour');
            })
            .catch(error => {
                addToast('danger', error.message);
            })
    }

    const handleDeleteQueue = () => {
        localStorage.setItem('api_queue', '');
        setApiQueue([]);
    }

    const handleSubmitConnect = (e) => {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        login(fields.email.value, fields.password.value)
            .catch((err) => {
                addToast('danger', 'Erreur lors de l\'identification : ' + err.message);
            })
            .then((data) => {
                if (typeof data != 'undefined' && data.token) {
                    localStorage.setItem('bearerToken', data.token);
                    localStorage.setItem('refreshToken', data.refresh_token);
                    localStorage.setItem('username', fields.email.value);
                    localStorage.setItem('connected', '1');
                    setUsername(fields.email.value);
                    setConnected(true);
                    handleRefreshData();
                }
                else if (typeof data != 'undefined') {
                    addToast('warning', 'Vos identifiants n\'ont pas été reconnus' + data);
                }
            })
    };

    const handleSubmitDisconnect = (e) => {
        e.preventDefault();
        e.returnValue = '';
        localStorage.setItem('bearerToken', '');
        localStorage.setItem('refreshToken', '');
        localStorage.setItem('username', '');
        localStorage.setItem('connected', '');
        setUsername("");
        setConnected(false);
        // @todo empty animals and events lists
    };

    const handleDisplayArchiveChange = (e) => {
        localStorage.setItem('displayArchive', e.target.checked);
        setDisplayArchive(e.target.checked);
        loadData(tableData, setTableData, setAnimals, setLocations, setMarkers, setEvents, setCategories, setConfig)
    };

    return (
        <>
            <div class="d-grid gap-2">
                Behhh version {process.env.PREACT_APP_BEHHH_VERSION} du {process.env.PREACT_APP_BEHHH_DATE}<br />
                {config && config['instanceName'] && <>{config['instanceName']}<br /></>}
                <strong>{newVersion}</strong>
            </div>
            <div>
                {!connected &&
                    <div>
                        <form onSubmit={handleSubmitConnect}>
                            <input type="email" placeholder="Votre email" name="email" id="email" /><br />
                            <input type="password" placeholder="Votre mot de passe" name="password" id="password" /><br />
                            <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-2">
                                <input class="btn btn-primary" type="submit" value="Connexion" />
                            </div>
                        </form>
                    </div>
                }
                {connected &&
                    <p>
                        Vous êtes connecté en tant que : {username}
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-2">
                            <button type="button" class="btn btn-secondary" onClick={handleSubmitDisconnect}>
                                Déconnexion
                            </button>
                        </div>
                    </p>
                }
                <div>
                    <input id="displayArchiveChk" name="displayArchiveChk" type="checkbox" onChange={handleDisplayArchiveChange} checked={displayArchive} />
                    <label for="displayArchiveChk">&nbsp;Voir aussi les éléments archivés</label>
                </div>
            </div>
            {
                apiQueue.length > 0 &&
                <div class="d-grid gap-2 mt-2 mb-2">
                    <strong>{apiQueue.length} éléments en attente de synchronisation<br /></strong>
                    {
                        apiQueue.map((q) => {
                            return (
                                <div class="small overflow-scroll">
                                    <span class="fw-bold">{q.type} {q.path} :</span>
                                    <br />{JSON.stringify(q.data)}
                                </div>
                            )
                        })
                    }
                </div>
            }
            <div class="d-grid gap-2">
                <button type="button" class="btn btn-primary" onClick={handleRefreshData}>
                    Synchroniser les données
                </button>
            </div>
            {
                apiQueue.length > 0 &&
                <div class="d-grid gap-2 mt-2">
                    <button type="button" class="btn btn-danger" onClick={handleDeleteQueue}>
                        Supprimer les éléments en attente
                    </button>
                </div>
            }
        </>
    );
}